import { render, staticRenderFns } from "./pabauPane.vue?vue&type=template&id=3cbb9815"
import script from "./pabauPane.vue?vue&type=script&lang=js"
export * from "./pabauPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports